<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" md="8" lg="6" xl="5">
        <v-card class="ui-module-card ui-module-fade-in-up registro-arma-shell" color="primary">
          <v-card-title class="ui-module-titlebar justify-center font-weight-bold">Registro de arma nueva</v-card-title>
          <v-card-text>
            <v-container>
              <v-row align="center">
                <v-col cols="4" align="center">
                  <v-progress-circular
                    :value="activeStep * 25"
                    size="96"
                    width="12"
                    color="secondary"
                    rotate="-90"
                  ></v-progress-circular>
                </v-col>
                <v-col cols="8">
                  <div class="text-caption">
                    PASO {{ activeStep }}
                    <div v-if="activeStep == 4" class="d-inline">(Opcional)</div>
                  </div>
                  <div class="text-subtitle-1 font-weight-bold">{{ activeStepTitle }}</div>
                  <a class="text-decoration-none" v-show="activeStep != 1" v-on:click="activeStep--"
                    >Volver al paso anterior</a
                  >
                </v-col>
              </v-row>
            </v-container>
            <v-container>
              <v-row>
                <transition name="fade" mode="out-in">
                  <v-col md="12" v-if="activeStep == 1" key="1">
                    <v-select
                      class="ui-form-field"
                      v-model="selectedWeaponType"
                      filled
                      rounded
                      dense
                      background-color="transparent"
                      color="secondary"
                      :items="weaponTypes"
                      label="Tipo de arma"
                      item-value="id"
                      item-text="title"
                      v-on:change="weaponClassesHandler()"
                    ></v-select>
                    <v-select
                      class="ui-form-field"
                      v-model="arma.fk_idClase"
                      filled
                      rounded
                      dense
                      background-color="transparent"
                      color="secondary"
                      label="Clase de arma"
                      :items="weaponClasses"
                      item-value="id"
                      item-text="clase"
                      :disabled="loadingWeaponClasses || !selectedWeaponType"
                    ></v-select>
                    <v-select
                      class="ui-form-field"
                      v-on:change="arma.fk_idModelo = null"
                      filled
                      rounded
                      dense
                      background-color="transparent"
                      color="secondary"
                      label="Marca"
                      :items="weaponBrands"
                      item-value="id"
                      item-text="title"
                      v-model="selectedWeaponBrand"
                    ></v-select>
                    <v-select
                      class="ui-form-field"
                      v-model="arma.fk_idModelo"
                      filled
                      rounded
                      dense
                      background-color="transparent"
                      color="secondary"
                      label="Modelo"
                      :items="filteredWeaponModelsByBrand"
                      item-value="id"
                      item-text="modelo"
                      :disabled="!selectedWeaponBrand"
                    ></v-select>
                  </v-col>
                  <v-col md="12" v-if="activeStep == 2" key="2">
                    <v-row>
                      <v-col cols="6">
                        <v-select
                          class="ui-form-field"
                          filled
                          rounded
                          dense
                          background-color="transparent"
                          color="secondary"
                          label="Calibre"
                          :items="calibers"
                          item-value="id"
                          item-text="title"
                          v-model="arma.fk_idCalibre"
                        ></v-select>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          class="ui-form-field"
                          v-model="arma.serie"
                          background-color="transparent"
                          color="secondary"
                          label="Número de inventario"
                          filled
                          rounded
                          dense
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          class="ui-form-field"
                          v-model="arma.matricula"
                          background-color="transparent"
                          color="secondary"
                          label="Matrícula"
                          filled
                          rounded
                          dense
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          class="ui-form-field"
                          v-model="arma.observaciones"
                          background-color="transparent"
                          color="secondary"
                          label="Observaciones"
                          filled
                          rounded
                          dense
                        ></v-text-field>
                        <v-select
                          class="ui-form-field"
                          v-model="arma.fk_idCatProcedenciaArma"
                          filled
                          rounded
                          dense
                          background-color="transparent"
                          color="secondary"
                          label="Procedencia del arma"
                          :items="procedencia"
                          item-value="id"
                          item-text="title"
                          item-color="secondary"
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col md="12" v-if="activeStep == 3" key="3">
                    <v-row>
                      <v-col cols="7" class="pb-0">
                        <v-text-field
                          class="ui-form-field"
                          background-color="transparent"
                          color="secondary"
                          filled
                          rounded
                          dense
                          v-model="arma.noEconomico"
                          label="Número económico"
                          type="number"
                          :disabled="loading"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="5" class="pb-0">
                        <v-select
                          class="ui-form-field"
                          v-model="arma.fk_idEstatus"
                          filled
                          background-color="transparent"
                          color="secondary"
                          rounded
                          dense
                          :items="weaponStatus"
                          item-value="id"
                          item-text="title"
                          label="Estatus"
                          :disabled="loading"
                        ></v-select>
                      </v-col>
                      <v-col cols="6" class="py-0">
                        <v-text-field
                          class="ui-form-field"
                          v-model="arma.folioC"
                          label="Folio C"
                          background-color="transparent"
                          color="secondary"
                          filled
                          rounded
                          dense
                          :disabled="loading"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6" class="py-0">
                        <v-text-field
                          class="ui-form-field"
                          v-model="arma.folioD"
                          label="Folio D"
                          background-color="transparent"
                          color="secondary"
                          filled
                          rounded
                          dense
                          :disabled="loading"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" class="py-0">
                        <v-text-field
                          class="ui-form-field"
                          v-model="arma.armeros"
                          label="Armeros"
                          background-color="transparent"
                          color="secondary"
                          filled
                          rounded
                          dense
                          :disabled="loading"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                </transition>
              </v-row>
            </v-container>
            <v-container>
              <v-row>
                <v-col md="12" xl="6" offset-xl="3">
                  <v-btn
                    block
                    color="secondary"
                    class="ui-module-btn-solid"
                    v-on:click="activeStepButtonHandler"
                    :loading="loading"
                    :disabled="!validActiveStep || loading"
                    >{{ activeStepButtonLabel }}</v-btn
                  >
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.card-flat {
  box-shadow: none !important;
  transition: 0.3s;
}
</style>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'

export default {
  data() {
    return {
      loading: false,
      loadingWeaponClasses: false,
      activeStep: 1,
      selectedWeaponType: null,
      selectedWeaponBrand: null,

      arma: {
        serie: '',
        folio: '',
        matricula: '',
        noEconomico: 0,
        folioC: '',
        folioD: '',
        loc: '',
        fechaAltaLoc: '01/01/1999',
        fk_idSubsede: null,
        armeros: '',
        fk_idModelo: null,
        fk_idClase: null,
        fk_idCalibre: null,
        fk_idEstatus: null,
        fk_idCatProcedenciaArma: null,
      },
    }
  },

  computed: {
    ...mapGetters('tipoArma', {
      weaponTypes: 'getTipoArmas',
    }),

    ...mapGetters('marcaArma', {
      weaponBrands: 'getMarcaArma',
    }),

    ...mapGetters('claseArma', {
      weaponClasses: 'getClasesArma',
    }),

    ...mapGetters('modeloArma', {
      modeloArma: 'getModelosArmas',
    }),

    ...mapGetters('calibre', {
      calibers: 'getCalibres',
    }),

    ...mapGetters('estatusArma', {
      weaponStatus: 'getEstatusArma',
    }),

    ...mapGetters('procedencia', {
      procedencia: 'getProcedencia',
    }),

    activeStepTitle: function () {
      switch (this.activeStep) {
        case 1:
          return 'Tipo de arma'
        case 2:
          return 'Información del arma'
        case 3:
          return 'Administración del arma'
      }
    },

    validActiveStep: function () {
      switch (this.activeStep) {
        case 1:
          if (this.selectedWeaponType && this.selectedWeaponBrand && this.arma.fk_idModelo) {
            return true
          } else {
            return false
          }
        case 2:
          if (this.arma.fk_idCalibre && this.arma.serie != '' && this.arma.fk_idCatProcedenciaArma) {
            return true
          } else {
            return false
          }
        // case 3:
        //     if (this.weaponLocEntryDate) {
        //         return true
        //     } else return false
        case 3:
          return true
      }
    },

    filteredWeaponModelsByBrand: function () {
      return this.modeloArma.filter((modelo) => {
        return modelo.CatMarca.id == this.selectedWeaponBrand
      })
    },

    activeStepButtonLabel: function () {
      if (this.activeStep < 3) {
        return 'Siguiente paso'
      } else {
        return 'Registrar arma'
      }
    },

    getMaxDay: function () {
      return moment().format(this.VUETIFY_DATE_FORMAT)
    },
  },

  methods: {
    ...mapActions('claseArma', ['fetchClasesArma']),

    ...mapActions('arma', ['saveArma']),

    activeStepButtonHandler: async function () {
      if (this.activeStep < 3) {
        this.activeStep++
      } else {
        this.loading = true
        await this.saveArma(this.arma)
        this.loading = false
        this.$router.push('/armeria/dashboard')
      }
    },

    weaponClassesHandler: async function () {
      this.selectedWeaponClass = null
      this.loadingWeaponClasses = true
      await this.fetchClasesArma(this.selectedWeaponType)
      this.loadingWeaponClasses = false
    },
  },
}
</script>

<style scoped>
.registro-arma-shell {
  min-height: calc(100vh - 64px);
  min-height: calc(100dvh - 64px);
}

/* Indicador de progreso circular */
::v-deep .v-progress-circular {
  transition: all 0.3s ease;
}

::v-deep .v-progress-circular__overlay {
  stroke: #6c5ce7 !important;
}

/* Campos de formulario */
::v-deep .ui-form-field {
  margin-bottom: 16px;
}

::v-deep .ui-form-field .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(108, 92, 231, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  min-height: 48px !important;
  transition: all 0.3s ease !important;
}

::v-deep .ui-form-field .v-input__slot:hover {
  border-color: rgba(108, 92, 231, 0.45) !important;
}

::v-deep .ui-form-field .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field input,
::v-deep .ui-form-field textarea,
::v-deep .ui-form-field .v-select__selection,
::v-deep .ui-form-field .v-select__selections,
::v-deep .ui-form-field .mdi-menu-down {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
  font-weight: 500;
}

::v-deep .ui-form-field.v-input--is-focused .v-label,
::v-deep .ui-form-field .v-label--active {
  color: #a29bfe !important;
}

::v-deep .ui-form-field .v-input__icon .v-icon,
::v-deep .ui-form-field .v-input__append-inner .v-icon {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-input__icon .v-icon,
::v-deep .ui-form-field.v-input--is-focused .v-input__append-inner .v-icon {
  color: #a29bfe !important;
}

/* Mensajes de ayuda y errores */
::v-deep .v-messages__message {
  color: #a0a0a0 !important;
}

::v-deep .error--text .v-messages__message {
  color: #ff5252 !important;
}

/* Iconos */
::v-deep .v-icon {
  color: #e0e0e0;
  transition: all 0.3s ease;
}

::v-deep .v-btn .v-icon {
  margin-right: 8px;
}

::v-deep .v-btn:hover .v-icon {
  color: #ffffff !important;
}

/* Select items (dropdown) */
::v-deep .v-select__selections {
  color: #e0e0e0 !important;
}

::v-deep .v-select__selection {
  color: #e0e0e0 !important;
}

/* Menu del select */
::v-deep .v-menu__content {
  background: rgba(30, 30, 46, 0.95) !important;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(108, 92, 231, 0.3);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
}

::v-deep .v-list {
  background: transparent !important;
  padding: 8px;
}

::v-deep .v-list-item {
  border-radius: 8px;
  margin: 2px 0;
  transition: all 0.2s ease;
}

::v-deep .v-list-item:hover {
  background: rgba(108, 92, 231, 0.2) !important;
}

::v-deep .v-list-item__title {
  color: #e0e0e0 !important;
}

::v-deep .v-list-item--active {
  background: rgba(108, 92, 231, 0.3) !important;
}

/* Dividers */
::v-deep .v-divider {
  border-color: rgba(108, 92, 231, 0.2) !important;
}

/* Pasos del formulario - indicador visual */
.step-indicator {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 32px;
}

.step-indicator .v-progress-circular {
  margin: 0 8px;
}

/* Animaciones suaves */
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

/* ==================== TOOLTIPS ==================== */
::v-deep .v-tooltip__content {
  background: rgba(30, 30, 46, 0.95) !important;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(108, 92, 231, 0.3);
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  padding: 8px 12px;
  font-size: 0.875rem;
  font-weight: 500;
}

/* ==================== SCROLLBAR ==================== */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(108, 92, 231, 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(108, 92, 231, 0.6);
}

/* ==================== BOTONES CON RIPPLE ==================== */
::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn:active::before {
  width: 300px;
  height: 300px;
}
</style>
